// extracted by mini-css-extract-plugin
export var divider = "_q6-0";
export var systemMessage = "_q6-1";
export var systemMessageWrapper = "_q6-2";